"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var LNBDetectionStatues;
(function (LNBDetectionStatues) {
    LNBDetectionStatues[LNBDetectionStatues["ready"] = 0] = "ready";
    LNBDetectionStatues[LNBDetectionStatues["inprogress"] = 1] = "inprogress";
    LNBDetectionStatues[LNBDetectionStatues["ok"] = 2] = "ok";
    LNBDetectionStatues[LNBDetectionStatues["failed"] = -2] = "failed";
})(LNBDetectionStatues = exports.LNBDetectionStatues || (exports.LNBDetectionStatues = {}));
//# sourceMappingURL=LNBDetectionType.js.map